// This is the configuration file for Ant Design's theming system.

const theme = {
  // The "token" object is used for global style variables.
  token: {
    // --- Centralized Font Configuration ---
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      "\"Segoe UI\"",
      "Roboto",
      "\"Helvetica Neue\"",
      "Arial",
      "sans-serif",
    ].join(","),

    // Font sizes for different elements
    // fontSize: 16, // Default body text size
    // fontSizeHeading3: 28, // For main page titles (e.g., "Submit Schrodinger Job")
    // fontSizeHeading4: 20, // For card titles (e.g., "Selected Molecules")
    // fontSizeHeading5: 20, // For section subheadings (e.g., "Selection Details")

    // // --- Centralized Color Palette ---
    // colorPrimary: '#003A6C', // Your existing primary color
    // // colorInfo: '#003A6C',    // You can alias colors like this
    // colorBgLayout: '#f0f2f5', // The light gray background for the main layout
  },

  // The "components" object is for component-specific style overrides.
  components: {
    Card: {
      borderRadius: 8, // Consistent border radius for all cards
      boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)", // A subtle shadow
    },
    Button: {
      borderRadius: 6,
      // Ant Design buttons are not all caps by default, so no change is needed here.
    },
    Layout: {
      headerBg: "#ffffff", // Set a white background for the header
    }
  },
};

export default theme;
